import { createContext, FC, useContext, useEffect } from 'react';
import { Loading } from '../components';
import { useLocalStorage } from '../hooks';
import { useGlobalApi } from '../api-tools';
import { Company } from './types';

export const CompanyContext = createContext({
  currentCompany: 0,
  setCurrentCompany: (_: number) => {},
  companyList: [] as Company[],
});

export const useCompany = () => useContext(CompanyContext);

export const CompanyProvider: FC = ({ children }) => {
  const [currentCompany, setCurrentCompany] = useLocalStorage<number>('currentCompany', 0);
  const [companyList] = useGlobalApi<Company[]>('/api/v3/companies');

  useEffect(() => {
    if (companyList === undefined) {
      return;
    }
    if (companyList.length === 0) {
      setCurrentCompany(0);
      return;
    }
    // Ставим текущей первую компанию из списка, если компания ранее не установлена либо была удалена
    if (
      currentCompany === 0 ||
      companyList.find((company) => company.id === currentCompany) === undefined
    ) {
      setCurrentCompany(companyList[0].id);
    }
  }, [companyList]);

  // Пока не получен список компаний, или бэкенд еще не вернул обновленный список с добавленной компанией
  if (
    companyList === undefined ||
    (companyList.length !== 0 && !companyList.some((company) => company.id === currentCompany))
  ) {
    return <Loading />;
  }

  return (
    <CompanyContext.Provider
      value={{
        currentCompany,
        setCurrentCompany,
        companyList,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
};
